import React, { useMemo } from 'react'
import IFrame from 'components/IFrame'
import styled from 'styled-components'

const Wrapper = styled.div`
  & {
    display: inline-block;
    width: 100%;
    height: 750px;
    padding: 0;
    overflow: hidden;
  }

  .scale-frame {
    width: calc(100% * 2);
    height: 1000px;
    border: 0px;
    transform: scale(0.75);
    transform-origin: -50% top;
  }
`

const UNSUBSCRIBE_HREF_TOKENS = [
  'asm_preferences_raw_url',
  'asm_group_unsubscribe_raw_url',
  'asm_global_unsubscribe_raw_url',
  'raw_unsubscribe_link',
]

function replaceAll(source, mapping) {
  const re = new RegExp(Object.keys(mapping).join('|'), 'gi')
  return source.replace(re, (matched) => mapping[matched.toLowerCase()])
}

function openLinksInNewTab(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  doc.querySelectorAll('a').forEach((anchor) => {
    const href = anchor.getAttribute('href') || ''
    const isUnsubscribe = UNSUBSCRIBE_HREF_TOKENS.some((token) => href.includes(token))
    if (isUnsubscribe) {
      anchor.removeAttribute('href')
      return
    }
    anchor.setAttribute('target', '_blank')
    anchor.setAttribute('rel', 'noopener noreferrer')
  })
  return doc.documentElement.outerHTML
}

function EmailSurveyTemplatePreview({
  introHTML,
  outroHTML,
  template,
  senderName,
  senderEmail,
  domain,
  subject,
}) {
  const processedTemplate = useMemo(() => openLinksInNewTab(template), [template])
  const previewHTML = useMemo(
    () =>
      replaceAll(processedTemplate, {
        '{{{ intro }}}': introHTML,
        '{{{ outro }}}': outroHTML,
      }),
    [processedTemplate, introHTML, outroHTML]
  )

  return (
    <div className="ui segments">
      <div
        className="ui compact segment"
        style={{ paddingTop: '.3em', paddingBottom: '.1em', backgroundColor: '#F8F8F8' }}
      >
        <div className="ui white basic empty circular label" />{' '}
        <div className="ui white basic empty circular label" />{' '}
        <div className="ui white basic empty circular label" />
      </div>
      <div className="ui segment">
        <p className="text-grey">
          <strong>From:</strong> {senderName} &lt;{senderEmail}
          {domain}&gt;
          <br />
          <strong>Subject:</strong> {subject}
        </p>
        <Wrapper>
          <IFrame
            className="scale-frame"
            sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          >
            <div dangerouslySetInnerHTML={{ __html: previewHTML }} />
          </IFrame>
        </Wrapper>
      </div>
    </div>
  )
}

export default EmailSurveyTemplatePreview



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmailSurveyTemplatePreview/index.js